<template>
  <div class="playback-wrapper" ref="progress" @click="clickProgress">
    <a-progress
      class="custom-progress"
      :percent="curPercent"
      :strokeWidth="5"
      :showInfo="false"
      strokeColor="#1890ff"
    />
    <div class="custom-progress-dot" :style="{ left: `${curPercent}%` }"></div>
  </div>
</template>

<script>
import * as turf from "@turf/turf";
export default {
  data() {
    return {
      marker: null,
      intervalTimer: null,
      curDataIndex: 0,
      curPercent: 0
    };
  },
  props: {
    map: {
      type: Object,
      default: () => {}
    },
    trackDataInfo: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    trackDataInfo() {
      this.curDataIndex = 0;
      this.play();
    }
  },
  mounted() {
    this.play();
  },
  beforeDestroy() {
    this.marker?.remove();
    if (this.intervalTimer) {
      clearInterval(this.intervalTimer);
    }
  },
  methods: {
    clickProgress(event) {
      const { data } = this.trackDataInfo;
      const progressRef = this.$refs.progress;
      const clickPosition = event.offsetX;
      const containerWidth = progressRef.offsetWidth;
      this.curDataIndex = Math.min(
        data.length - 1,
        Math.round((clickPosition / containerWidth) * (data.length - 1))
      );
      this.play();
    },
    play() {
      if (this.intervalTimer) {
        clearInterval(this.intervalTimer);
      }
      const { data } = this.trackDataInfo;
      if (!data.length) {
        this.$emit("playEnd");
        return;
      }
      let interval = 500;
      if (data.length > 100) {
        interval = (100 / data.length) * 500;
        interval = interval < 20 ? 20 : interval;
      }
      this.intervalTimer = setInterval(this.draw, interval);
    },
    draw() {
      const { columns, data } = this.trackDataInfo;
      // 判断当前index是否大于数据长度，清空定时器
      if (!data.length || this.curDataIndex >= data.length) {
        clearInterval(this.intervalTimer);
        this.$emit("playEnd");
        return;
      }
      const lngIndex = columns.indexOf("lng");
      const latIndex = columns.indexOf("lat");
      const prevDataIndex = this.curDataIndex == 0 ? 0 : this.curDataIndex - 1;
      const gcj02Prev = coordtransform.wgs84togcj02(
        data[prevDataIndex][lngIndex],
        data[prevDataIndex][latIndex]
      );
      const gcj02 = coordtransform.wgs84togcj02(
        data[this.curDataIndex][lngIndex],
        data[this.curDataIndex][latIndex]
      );

      const angle = this.calcAngleByCoords(gcj02Prev, gcj02);
      if (!this.marker) {
        this.marker = new AMap.Marker({
          // icon: "static/images/boat.png",
          icon: new AMap.Icon({
            image: "static/images/boat.png",
            imageSize: new AMap.Size(42, 42)
          }),
          anchor: "center",
          position: [gcj02[0], gcj02[1]],
          angle: angle,
          zIndex: 1000
        });
        this.map.add(this.marker);
      } else {
        this.marker.setPosition([gcj02[0], gcj02[1]]);
        this.marker.setAngle(angle);
      }

      this.curPercent = (this.curDataIndex / (data.length - 1)) * 100;
      this.curDataIndex++;
    },
    calcAngleByCoords(prevCoord, curCoord) {
      const point1 = turf.point(prevCoord);
      const point2 = turf.point(curCoord);
      const bearing = turf.bearing(point1, point2);
      return bearing;
    }
  }
};
</script>

<style lang="less" scoped>
.playback-wrapper {
  position: absolute;
  top: 10px;
  right: 160px;
  width: 720px;
  cursor: pointer;
}
.custom-progress /deep/ .ant-progress-inner {
  background-color: #8ac5ff;
}
.custom-progress-dot {
  position: relative;
  top: 50%;
  transform: translate(-50%, -14px);
  width: 12px;
  height: 12px;
  border-radius: 50%;
  pointer-events: none; /* 防止遮挡进度条的点击事件 */
  transition: left 0.1s linear;
  background-color: #1890ff;
}
</style>
